<template >
  <SlideYUpTransition :duration="animationDuration">
    <div @keydown.esc="closeModal" class="modal fade"
      @mousedown.self="closeModal"
      :class="[{'show d-block': show}, {'d-none': !show}, {'modal-mini': type === 'mini'}]"
      v-show="show"
      tabindex="-1"
      role="dialog"
      :aria-hidden="!show"
      ref="modalBody"
    >

      <div class="modal-dialog modal-dialog-centered" v-if="show"
           :class="[{'modal-notice': type === 'notice', [`modal-${size}`]: size}, modalClasses]">

        <div class="modal-content" :class="[gradient ? `bg-gradient-${gradient}` : '', modalContentClasses]"
            :style="{ top: modalY + 'px', left: modalX + 'px', position: 'absolute'}">

          <div class="modal-header" :class="[headerClasses]" v-if="$slots.header" @mousedown="startDrag">
            <slot name="header"></slot>
            <slot name="close-button">
              <button type="button"
                      class="close"
                      v-if="showClose"
                      @click="closeModal"
                      data-dismiss="modal"
                      aria-label="Close">
                <span :aria-hidden="!show">×</span>
              </button>
            </slot>
          </div>

          <div class="modal-body" :class="bodyClasses">
            <slot></slot>
          </div>

          <div class="modal-footer" :class="footerClasses" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </SlideYUpTransition>
</template>
<script>
  import { SlideYUpTransition } from "vue2-transitions";
  import swal from "sweetalert2";


  export default {
    name: "modal",
    components: {
      SlideYUpTransition
    },
    props: {
      draggable: {
        type: Boolean,
        description: "Enable the draggable option",
        default: true // Valor padrão: true (draggable habilitado)
      },
      show: Boolean,
      showClose: {
        type: Boolean,
        default: true
      },
      mouseDownOn :{
        type: Boolean,
        default: true,
      },
      type: {
        type: String,
        default: "",
        validator(value) {
          let acceptedValues = ["", "notice", "mini"];
          return acceptedValues.indexOf(value) !== -1;
        },
        description: 'Modal type (notice|mini|"") '
      },
      modalClasses: {
        type: [Object, String],
        description: "Modal dialog css classes"
      },
      size: {
        type: String,
        description: 'Modal size',
        validator(value) {
          let acceptedValues = ["", "sm", "lg", "xl"];
          return acceptedValues.indexOf(value) !== -1;
        },
      },
      modalContentClasses: {
        type: [Object, String],
        description: "Modal dialog content css classes"
      },
      gradient: {
        type: String,
        description: "Modal gradient type (danger, primary etc)"
      },
      headerClasses: {
        type: [Object, String],
        description: "Modal Header css classes"
      },
      bodyClasses: {
        type: [Object, String],
        description: "Modal Body css classes"
      },
      footerClasses: {
        type: [Object, String],
        description: "Modal Footer css classes"
      },
      animationDuration: {
        type: Number,
        default: 500,
        description: "Modal transition duration"
      }, 
     
    },
    data() {
      return {
        modalX: 0, // Coordenadas do modal
        modalY: 0,
        isDragging: false,
        offsetX: 0,
        offsetY: 0,
      };
    },
    methods: {
      focusOnModal() {
        this.$nextTick(() => {
          this.$refs.modalBody.focus()
        });
      },
      closeModal() {
        if(this.mouseDownOn){
          this.$emit("update:show", false);
          this.$emit("close");
        }else {
          swal.fire({
            title: `Deseja continuar?`,
            text: 'Alterações não serão salvas ao fechar essa janela sem salvá-las.',
            buttonsStyling: false,
            icon: 'info',
            showCancelButton: true,
            cancelButtonClass: 'btn btn-warning',
            cancelButtonText: "Fechar",
            confirmButtonClass: 'btn btn-success mr-2',
            confirmButtonText: 'Continuar'
          }).then((result)=>{
            if (result.isDismissed) {
              this.$emit("update:show", false);
              this.$emit("close");
            }
          })
        }

      },
      centerModal() {
        // Obtemos o tamanho da janela visível
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        // Selecionamos o modal e obtemos as dimensões reais
        this.$nextTick(() => {
          const modalElement = this.$el.querySelector('.modal-content');
          if (modalElement) {
            const { width, height } = modalElement.getBoundingClientRect();

            // Calculamos a posição central com base nas dimensões reais do modal
            this.modalX = (screenWidth - width) / 2;
            this.modalY = (screenHeight - height) / 2;
          }
        });
      },
      startDrag(event) {
        if (this.draggable) {

          // Verifica se o elemento clicado não é um input, textarea, botão ou outro interativo
          const nonDraggableTags = ["INPUT", "TEXTAREA", "BUTTON", "SELECT"];
          if (nonDraggableTags.includes(event.target.tagName)) {
            return; // Não inicia o drag
          }

          this.isDragging = true;
          this.offsetX = event.clientX - this.modalX;
          this.offsetY = event.clientY - this.modalY;

          window.addEventListener("mousemove", this.onDrag);
          window.addEventListener("mouseup", this.stopDrag);

          event.preventDefault();
        }
      },
      onDrag(event) {
        if (this.isDragging) {
          const screenWidth = window.innerWidth;
          const screenHeight = window.innerHeight;

          // Obtém a largura do menu lateral (ajuste o seletor conforme necessário)
          const sidebarElement = document.querySelector('.sideBar'); // Substitua pelo seletor correto do menu
          let sidebarWidth = 0;

          if (sidebarElement) {
            const style = getComputedStyle(sidebarElement);
            // Verifica se o menu está visível
            if (
              style.display !== 'none' && // Certifica que o menu não está escondido
              style.visibility !== 'hidden' && // Certifica que o menu não está invisível
              style.transform === 'none' // Verifica se o menu não está fora da tela (caso use transform)
            ) {
              sidebarWidth = sidebarElement.getBoundingClientRect().width; // Obtém a largura real
            }
          }

          // Calcula a largura disponível
          const visibleWidth = screenWidth - sidebarWidth;
                
          // Seleciona o modal e obtém suas dimensões reais
          const modalElement = this.$el.querySelector('.modal-content');
          if (!modalElement) return;
          const { width, height } = modalElement.getBoundingClientRect();

          // Calcula novas posições
          let newX = event.clientX - this.offsetX;
          let newY = event.clientY - this.offsetY;

          // Ajuste horizontal: limitar entre 0 e a largura da tela menos a largura do modal
          if (newX < sidebarWidth) newX = sidebarWidth; // Limite esquerdo
          if (newX + width > screenWidth) newX = screenWidth - width; // Limite direito

          // Ajuste vertical: limitar entre 0 e a altura da tela menos a altura do modal
          if (newY < 0) newY = 0; // Limite superior
          if (newY + height > screenHeight) newY = screenHeight - height; // Limite inferior

          // Atualiza as coordenadas
          this.modalX = newX;
          this.modalY = newY;
        }
      },
      stopDrag() {
        this.isDragging = false;
        window.removeEventListener("mousemove", this.onDrag);
        window.removeEventListener("mouseup", this.stopDrag);
      },
      handleResize() {
        // Reposiciona o modal para garantir que esteja visível
        this.centerModal();
      },
    },
    watch: {
      show(val) {
        let documentClasses = document.body.classList;
        
        if (!val) {
          documentClasses.remove("modal-open");
          return;
        }

        documentClasses.add("modal-open");
        this.centerModal(); // Centraliza o modal quando aberto
        this.focusOnModal()
      },
    },
    mounted() {
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
   };
</script>

<style>
  .permit-overflow {
    overflow: visible !important;
  }

  .modal.show {
    background-color: rgba(0, 0, 0, 0.3);
  }
  /**
  Sobrescreve a propriedade margin 
  para que a regra de draggable 
  funcione adequadamente com os 
  diferentes tamanhos das modais
  */
  body .modal-dialog {
    height: 100vh;
    width: 100vh;
    margin: 0; 
  }
  .modal-sm {
    max-width: 380px;
  }
  /* Define que a área de drag (cabeçalho do modal) tenha um cursor de "mão aberta" */
  .modal-header {
    cursor: grab;
  }

  /* Quando o usuário estiver arrastando, muda para "mão fechada" */
  .modal-header:active {
    cursor: grabbing;
  }
</style>
